import React, { useEffect } from "react";

const useTitle = (title) => {
	return useEffect(() => {
		document.title = `Ivanvielled | ${title}`;
	}, []);
};

export default useTitle;
